import { Link } from "react-router-dom";
import { t, tf } from "@/lib/i18n";
import { ArrowUpRight, MapPin } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import Reveal from "@/components/Reveal";

export default function FinalCta() {
  const { content: c } = useSite();
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16" data-testid="final-cta-section">
      <Reveal className="relative overflow-hidden rounded-[36px] bg-[var(--stone)] p-8 sm:p-14 grid md:grid-cols-12 gap-8 items-center">
        <div className="absolute -right-16 -bottom-16 w-72 h-72 rounded-full border-[18px] border-[var(--leaf)]/10" />
        <img src="/icon-192.png" alt="" className="hidden md:block md:col-span-2 w-28 h-28 rounded-full shadow-xl floaty" />
        <div className="md:col-span-6 relative">
          <h2 className="text-3xl sm:text-4xl font-bold leading-tight">{t("Got a pile of old newspapers?")}</h2>
          <p className="mt-3 text-[var(--ink-soft)]">{tf("Book your first pickup in under a minute. Not in {city} yet?", { city: c.launch_city })} <Link to="/contact" className="font-semibold text-[var(--leaf-dark)] link-u" data-testid="final-cta-city-link">{t("Tell us your city")}</Link>.</p>
        </div>
        <div className="md:col-span-4 flex flex-col gap-3 relative">
          <a href={c.consumer_app_url} className="btn-leaf" data-testid="final-cta-book-btn">{c.consumer_cta_label} <ArrowUpRight size={18} /></a>
          <a href={c.partner_app_url} className="btn-ghost" data-testid="final-cta-partner-btn">{c.partner_cta_label} <ArrowUpRight size={18} /></a>
          <span className="inline-flex items-center justify-center gap-1.5 text-xs text-[var(--ink-soft)]"><MapPin size={13} /> {tf("Currently serving {city}", { city: c.launch_city })}</span>
        </div>
      </Reveal>
    </section>
  );
}
